import axios from 'axios';

const API_BASE_URL = '/api';

export default {
  namespaced: true,
  state: {
    URLS: {

      // AuthFrontend
      // 前端登入相關
      LOGIN: `${API_BASE_URL}/auth/login`,
      // LOGINLINE: `${API_BASE_URL}/user/lineLogin`,
      AuthRegister: `${API_BASE_URL}/auth/register`,
      AuthResendCertifyEmail: `${API_BASE_URL}/auth/resendCertifyEmail`,
      AuthActivateMemberByEmailCertify: `${API_BASE_URL}/auth/activateMemberByEmailCertify`,
      REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh`,
      GET_USER_INFO: `${API_BASE_URL}/auth/me`,
      AuthForgetPassword: `${API_BASE_URL}/auth/forgetPassword`,
      AuthResetPasswordByForgetPasswordToken: `${API_BASE_URL}/auth/resetPasswordByForgetPasswordToken`,
      AuthChangePassword: `${API_BASE_URL}/auth/changePassword`,
      AuthGoogleLogin: `${API_BASE_URL}/auth/googleLogin`,

      // UserFrontend
      // 前端會員管理
      UserUpdateInfo: `${API_BASE_URL}/user/updateInfo`,
      UserUploadProfileImage: `${API_BASE_URL}/user/uploadProfileImage`,
      UserRemoveProfileImage: `${API_BASE_URL}/user/removeProfileImage`,

      // TypeFaceFrontend
      // 前端字體相關
      TypefaceList: `${API_BASE_URL}/typeface/list`,
      TypefaceInfo: `${API_BASE_URL}/typeface/info`,
      TypefaceUpdateInfo: `${API_BASE_URL}/typeface/updateInfo`,
      TypefaceCreate: `${API_BASE_URL}/typeface/create`,
      TypefaceRemove: `${API_BASE_URL}/typeface/remove`,
      TypefaceGlyphs: `${API_BASE_URL}/typeface/glyphs`,
      TypefaceSetSystemName: `${API_BASE_URL}/typeface/setSystemName`,
      TypefaceTestSystemName: `${API_BASE_URL}/typeface/testSystemName`,
      TypefaceQueryGlyphs: `${API_BASE_URL}/typeface/queryGlyphs`,
      TypefaceUpdateTitleGlyph: `${API_BASE_URL}/typeface/updateTitleGlyph`,
      TypefaceRemoveTitleGlyph: `${API_BASE_URL}/typeface/removeTitleGlyph`,

      // BuildRequestFrontend
      // 前端字體打包創建相關
      BuildRequestBuild: `${API_BASE_URL}/buildRequest/build`,
      BuildRequestList: `${API_BASE_URL}/buildRequest/list`,

      // 字形相關
      GlyphCreateByBase64: `${API_BASE_URL}/glyph/createGlyph`,

      // 前端字形相關
      GlyphImgToken: `${API_BASE_URL}/glyph/imgToken`,
      GlyphInfo: `${API_BASE_URL}/glyph/info`,
      GlyphSetGlyphUsing: `${API_BASE_URL}/glyph/setGlyphUsing`,
      GlyphSvgString: `${API_BASE_URL}/glyph/svgString`,
      GlyphSvgAdjust: `${API_BASE_URL}/glyph/adjustGlyphLook`,
    }
  },
  getters: {
    axiosConfig(state, getters, rootState) {
      return {
        headers: {
          'token': rootState.auth.token,
          'Cache-Control': 'no-cache',
          // 'Content-Type': 'application/json',
        }
      };
    },
  },
  mutations: {

  },
  actions: {
    postApiPromise({getters}, {url, data}) {
      return new Promise(function(resolve, reject) {
        const postData = data? data: {};
        axios.post(url, postData, getters.axiosConfig).then(function(d) {
          if (d.status === 200 && d.data.status === 'ok') {
            resolve(d.data.data);
          } else {
            console.log(d.data.reason)
            reject(d.data.reason);
          }
        }).catch(function(e) {
          reject(e);
        });
      });
    },
    postUploadFilePromise({getters}, {url, filename, file}) {
      const formData = new FormData();
      formData.append(filename, file);
      // const axiosConfig = {
      //   headers: {
      //     'token': getters.axiosConfig.headers.token,
      //     'Cache-Control': 'no-cache',
      //     'Content-Type': 'multipart/form-data',
      //   }
      // };
      const axiosConfig = JSON.parse(JSON.stringify(getters.axiosConfig)); //使用深拷貝, 使其不影響其他引用getters.axiosConfig的未知錯誤
      axiosConfig.headers['Content-Type'] = 'multipart/form-data';
      return new Promise(function(resolve, reject) {
        axios.post(url, formData, axiosConfig).then(function(d) {
          if (d.status === 200 && d.data.status === 'ok') {
            resolve(d.data.data);
          } else {
            reject(d.data.reason);
          }
        }).catch(function(e) {
          reject(e);
        });
      });
    },
    getApiPromise({getters}, {url}) {
      return new Promise(function(resolve, reject) {
        axios.get(url, getters.axiosConfig).then(function(d) {
          if (d.status === 200 && d.data.status === 'ok') {
            resolve(d.data.data);
          } else {
            reject(d.data.reason);
          }
        }).catch(function(e) {
          reject(e);
        });
      });
    },

    /* */
    // AuthFrontend
    // 前端登入相關
    postLoginPromise({dispatch, state}, {email, password}) {
      return dispatch('postApiPromise', {
        url: state.URLS.LOGIN,
        data: {
          loginID: email, 
          loginPsw: password
        }
      });
    },

    postLoginLinePromise({dispatch, state}, {code, callbackUri}) {
      return dispatch('postApiPromise', {
        url: state.URLS.LOGINLINE,
        data: {code, callbackUri}
      });
    },

    postAuthRegisterPromise({dispatch, state}, {email, name, password}) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthRegister,
        data: {email, name, password}
      });
    },

    postAuthResendCertifyEmail({dispatch, state}, {email}) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthResendCertifyEmail,
        data: {email}
      });
    },

    postAuthActivateMemberByEmailCertify({dispatch, state}, {email, token}) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthActivateMemberByEmailCertify,
        data: {email, token}
      });
    },

    postRefreshTokenPromise({dispatch, state}, token) {
      return dispatch('postApiPromise', {
        url: state.URLS.REFRESH_TOKEN,
        data: {token}
      });
    },

    getMePromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.GET_USER_INFO,
      });
    },

    postForgetPasswordPromise({dispatch, state}, loginID) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthForgetPassword,
        data: {loginID}
      });
    },

    postAuthResetPasswordByForgetPasswordTokenPromise({dispatch, state}, {loginID, token, newPsw}) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthResetPasswordByForgetPasswordToken,
        data: {loginID, token, newPsw}
      });
    },

    postChangePasswordPromise({dispatch, state}, newPassword) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthChangePassword,
        data: {newPassword}
      });
    },

    postAuthGoogleLoginPromise({dispatch, state}, code) {
      return dispatch('postApiPromise', {
        url: state.URLS.AuthGoogleLogin,
        data: {code}
      });
    },


    // UserFrontend
    // 前端會員管理
    postUserUpdateInfoPromise({dispatch, state}, {MemberName, MemberProfilePic, MemberBirthday, MemberAddress, MemberDescription, MemberGender}) {
      return dispatch('postApiPromise', {
        url: state.URLS.UserUpdateInfo,
        data: {MemberName, MemberProfilePic, MemberBirthday, MemberAddress, MemberDescription, MemberGender}
      });
    },

    postUserUploadProfileImagePromise({dispatch, state}, dataUrl) {
      return dispatch('postApiPromise', {
        url: state.URLS.UserUploadProfileImage,
        data: {dataUrl}
      });
    },

    postUserRemoveProfileImagePromise({dispatch, state}) {
      return dispatch('postApiPromise', {
        url: state.URLS.UserRemoveProfileImage,
      });
    },

    // TypeFaceFrontend
    // 前端字體相關
    getTypefaceListPromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.TypefaceList,
      });
    },

    getTypefaceInfoPromise({dispatch, state}, id) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.TypefaceInfo}/${id}`,
      });
    },

    postTypefaceUpdateInfoPromise({dispatch, state}, {id, TypeFaceName, TypeFaceDescription, TypeFacePreviewText, TypeFacePublic}) {
      return dispatch('postApiPromise', {
        url: `${state.URLS.TypefaceUpdateInfo}/${id}`,
        data: {TypeFaceName, TypeFaceDescription, TypeFacePreviewText, TypeFacePublic}
      });
    },

    postTypefaceCreatePromise({dispatch, state}, {name, description}) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceCreate,
        data: {name, description}
      });
    },

    postTypefaceRemovePromise({dispatch, state}, id) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceRemove,
        data: {id}
      });
    },

    getTypefaceGlyphsPromise({dispatch, state}, belongID) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.TypefaceGlyphs}/${belongID}`,
      });
    },

    postTypefaceSetSystemNamePromise({dispatch, state}, {id, systemName}) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceSetSystemName,
        data: {id, systemName}
      });
    },

    postTypefaceTestSystemNamePromise({dispatch, state}, systemName) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceTestSystemName,
        data: {systemName}
      });
    },

    postTypefaceQueryGlyphsPromise({dispatch, state},  {belongID, queryString}) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceQueryGlyphs,
        data: {belongID, queryString}
      });
    },

    postTypefaceUpdateTitleGlyphPromise({dispatch, state},  {typeFaceID, titleGlyphID}) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceUpdateTitleGlyph,
        data: {typeFaceID, titleGlyphID}
      });
    },

    postTypefaceRemoveTitleGlyphPromise({dispatch, state},  typeFaceID) {
      return dispatch('postApiPromise', {
        url: state.URLS.TypefaceRemoveTitleGlyph,
        data: {typeFaceID}
      });
    },

    // BuildRequestFrontend
    // 前端字體打包創建相關
    postBuildRequestBuildPromise({dispatch, state}, typeFaceId) {
      return dispatch('postApiPromise', {
        url: `${state.URLS.BuildRequestBuild}/${typeFaceId}`,
      });
    },

    getBuildRequestListPromise({dispatch, state}, typeFaceId) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.BuildRequestList}/${typeFaceId}`,
      });
    },

    // 字形相關
    postGlyphCreateByBase64Promise({dispatch, state}, {typefaceId, word, base64String}) {
      return dispatch('postApiPromise', {
        url: state.URLS.GlyphCreateByBase64,
        data: {
          typefaceId,
          word,
          base64String
        }
      });
    },

    // 前端字形相關
    getGlyphImgTokenPromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.GlyphImgToken,
      });
    },

    getGlyphInfoPromise({dispatch, state}, glyphId) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.GlyphInfo}/${glyphId}`,
      });
    },

    postGlyphSetGlyphUsingPromise({dispatch, state}, glyphId) {
      return dispatch('postApiPromise', {
        url: state.URLS.GlyphSetGlyphUsing,
        data: {glyphId}
      });
    },

    getGlyphSvgStringPromise({dispatch, state}, glyphId) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.GlyphSvgString}/${glyphId}`,
      });
    },

    postGlyphSvgAdjustPromise({dispatch, state}, {
      glyphId,
      dx,
      dy,
      rotate,
      scale
    }) {
      return dispatch('postApiPromise', {
        url: state.URLS.GlyphSvgAdjust,
        data: {
          glyphId,
          dx,
          dy,
          rotate,
          scale
        }
      });
    },


    
  },
}
